export const formatTaskStatus = (status) => {
  const value = String(status || "").trim().replace(/[_-]+/g, " ").toLowerCase();
  return value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : "";
};
